import { render } from "./ViewFlashMessageUserList.vue?vue&type=template&id=72563b83&scoped=true"
import script from "./ViewFlashMessageUserList.vue?vue&type=script&lang=js"
export * from "./ViewFlashMessageUserList.vue?vue&type=script&lang=js"

import "./ViewFlashMessageUserList.vue?vue&type=style&index=0&id=72563b83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72563b83"]])

export default __exports__